require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-77-welcome-to-teamgantt.json") })
        }
      }, "path---article-77-welcome-to-teamgantt");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-77-welcome-to-teamgantt!./.cache/json/article-77-welcome-to-teamgantt.json
// module id = 566
// module chunks = 231608221292675